import type { IconData } from '@stacksjs/iconify-core'

export const lc4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#65cfff\" d=\"M0 0h640v480H0z\"/><path fill=\"#fff\" d=\"m318.9 42l162.7 395.3l-322.6.9z\"/><path fill=\"#000001\" d=\"m319 96.5l140.8 340l-279 .8z\"/><path fill=\"#ffce00\" d=\"m318.9 240.1l162.7 197.6l-322.6.5z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default lc4x3
